import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { WeaveLogo } from "@/components/WeaveLogo";
import { FadeUp } from "@/components/Motion";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex flex-col" data-testid="payment-cancel-page">
      <header className="border-b border-weave-line bg-weave-cream/80 backdrop-blur-xl">
        <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 flex items-center">
          <Link to="/" aria-label="Back to home"><WeaveLogo /></Link>
        </div>
      </header>
      <main className="flex-1 flex items-center justify-center px-6 py-20">
        <FadeUp className="max-w-xl text-center">
          <h1 className="text-3xl md:text-4xl font-light text-weave-ink" data-testid="cancel-heading">
            No charge was made.
          </h1>
          <p className="mt-5 text-lg text-weave-slate leading-relaxed">
            You stepped away before completing the payment — nothing has been taken, and your
            place in the April 2027 cohort is still available whenever you’re ready.
          </p>
          <div className="mt-10 flex flex-wrap justify-center gap-4">
            <Link
              to="/academy"
              data-testid="cancel-academy-link"
              className="inline-flex items-center gap-2 bg-weave-teal text-white hover:bg-weave-tealdeep transition-colors duration-300 rounded-full px-7 py-3.5 font-medium"
            >
              Back to the Academy <ArrowRight size={16} />
            </Link>
            <Link
              to="/"
              data-testid="cancel-home-link"
              className="inline-flex items-center gap-2 border border-weave-teal text-weave-teal hover:bg-weave-teal/10 transition-colors duration-300 rounded-full px-7 py-3.5 font-medium"
            >
              Back to The Weave
            </Link>
          </div>
        </FadeUp>
      </main>
    </div>
  );
}
